/**
 * Web placeholder for CameraRadiationView - camera not available on web
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

export function CameraRadiationView() {
  return (
    <View style={styles.placeholder}>
      <Text style={styles.placeholderText}>
        Camera radiation detection is available on iOS and Android.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  placeholder: {
    padding: 24,
    backgroundColor: '#1e293b',
    borderRadius: 12,
    alignItems: 'center',
  },
  placeholderText: {
    color: '#94a3b8',
    fontSize: 14,
  },
});
